<template>
  <div>
    <div class="title-page flex items-center" style="padding: 1.3rem">
      <feather-icon icon="GlobeIcon" svgClasses="h-4 w-4"></feather-icon>
      <h3 class="font-bold mr-3" style="display: inline-block; font-size: 1.125rem">
        {{ $t("internationalWallet") }}
      </h3>
    </div>
    <div class="line"></div>

    <div v-if="loading" class="p-6 loading-table">
      <spinner-color />
    </div>

    <div v-else-if="error_msg" style="padding: 1.3rem">
      <vs-alert color="danger" icon="new_releases" :active="true">
        <span>{{ error_msg }}</span>
      </vs-alert>
    </div>

    <div v-else style="padding: 1.3rem">
      <div class="vx-row">
        <div class="vx-col w-full md:w-1/2 mb-4">
          <vs-card>
            <p class="mb-2">
              {{ $t("internationalShippingCode") }} :
              <span class="font-semibold">{{ wallet_summary.international_shipping_code || "-" }}</span>
            </p>
            <p>
              {{ $t("internationalWalletBalance") }} :
              <span class="font-semibold" style="color: #31006f; font-size: 1.1rem">
                {{ wallet_summary.international_wallet_balance }} $
              </span>
            </p>
          </vs-card>
        </div>

        <div class="vx-col w-full md:w-1/2 mb-4" v-if="wallet_summary.shipping_warehouses && wallet_summary.shipping_warehouses.length">
          <vs-card>
            <h4 class="mb-3">{{ $t("shippingWarehouseAddress") }}</h4>
            <div v-for="(warehouse, index) in wallet_summary.shipping_warehouses" :key="index" class="mb-2">
              <p class="font-semibold">{{ warehouse.name }}</p>
              <p v-if="warehouse.address">{{ warehouse.address }}</p>
              <p v-if="warehouse.contact_phone">{{ warehouse.contact_phone }}</p>
            </div>
          </vs-card>
        </div>
      </div>

      <vs-card class="mt-4">
        <h4 class="mb-3">{{ $t("internationalWalletMovements") }}</h4>
        <vs-table :data="wallet_movements" noDataText="">
          <template slot="thead">
            <vs-th>{{ $t("date") }}</vs-th>
            <vs-th>{{ $t("movementType") }}</vs-th>
            <vs-th>{{ $t("amountUsd") }}</vs-th>
            <vs-th>{{ $t("balanceAfterUsd") }}</vs-th>
            <vs-th>{{ $t("relatedShipment") }}</vs-th>
            <vs-th>{{ $t("notesOrder") }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
              <vs-td>{{ formatDate(tr.created_at) }}</vs-td>
              <vs-td>{{ tr.type.label }}</vs-td>
              <vs-td>{{ tr.amount_usd }}</vs-td>
              <vs-td>{{ tr.balance_after_usd }}</vs-td>
              <vs-td>{{ tr.shipment_code || "-" }}</vs-td>
              <vs-td>{{ tr.notes || "-" }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <empty-data v-if="!wallet_movements.length" />

        <div v-if="movementsTotalPages > 1" class="flex justify-center mt-4">
          <vs-pagination :total="movementsTotalPages" v-model="movementsPage" />
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SpinnerColor from "@/views/components/table-components/SpinnerColor2.vue";
import EmptyData from "@/views/components/table-components/EmptyData.vue";

export default {
  components: {
    SpinnerColor,
    EmptyData,
  },
  data() {
    return {
      loading: false,
      movementsPage: 1,
    };
  },
  computed: {
    ...mapGetters("internationalShipping", [
      "wallet_summary",
      "wallet_movements",
      "wallet_movements_pagination",
      "error_msg",
    ]),
    movementsTotalPages() {
      return this.wallet_movements_pagination ? this.wallet_movements_pagination.last_page : 1;
    },
  },
  watch: {
    movementsPage() {
      this.fetchWalletMovements({ page: this.movementsPage, perPage: 10 });
    },
  },
  methods: {
    ...mapActions("internationalShipping", ["fetchWalletSummary", "fetchWalletMovements"]),
    formatDate(value) {
      return new Date(value).toLocaleDateString("en-LY", {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "Africa/Tripoli",
      });
    },
  },
  async created() {
    this.loading = true;
    await this.fetchWalletSummary();
    await this.fetchWalletMovements({ page: 1, perPage: 10 });
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_loadingTable.scss";
</style>
